import {useEffect, useState} from "react";
import {validation} from "../../../../../helpers/ValidationHelper";

const defaultSettings = {
    heaterGridEnables: false,
    arcFaultProgram: 0,
    meanCathodeOverCurrent: 0,
    gridPulsedVoltage: 0,
    cathodeVoltage: 0,
    heaterVoltage: 0
};

function validateArcFaultProgramValue(value) {
    return value >= 1 && value <= 255;
}

function validateMeanCathodeOverCurrent(value) {
    return value >= 0 && value <= 10;
}

function validateGridPulsedVoltage(value) {
    return value >= 0 && value <= 15;
}

function validateCathodeVoltage(value) {
    return value >= 0 && value <= 15;
}

function validateHeaterVoltage(value) {
    return value >= 0 && value <= 6.5;
}

export default function UseSpellmanIcaControl({pipe, onChanged, onApply, onActions}) {
    const [settings, setSettings] = useState(defaultSettings);
    const [applying, setApplying] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const hasErrors = !!Object.keys(validationErrors).length;

    useEffect(() => {
        setSettings(pipe.settings ? {
            heaterGridEnables: pipe.settings["heater_grid_enables"] || defaultSettings.heaterGridEnables,
            arcFaultProgram: pipe.settings["arc_fault_program"] || defaultSettings.arcFaultProgram,
            meanCathodeOverCurrent: pipe.settings["mean_cathode_over_current"] || defaultSettings.meanCathodeOverCurrent,
            gridPulsedVoltage: pipe.settings["grid_pulsed_voltage"] || defaultSettings.gridPulsedVoltage,
            cathodeVoltage: pipe.settings["cathode_voltage"] || defaultSettings.cathodeVoltage,
            heaterVoltage: pipe.settings["heater_voltage"] || defaultSettings.heaterVoltage
        } : defaultSettings);
    }, [pipe.id, pipe.settings]);

    function handleHeaterGridEnablesChanged(value) {
        setSettings(Object.assign({}, settings, {heaterGridEnables: value}));
    }

    function handleArcFaultProgramChanged(value) {
        setValidationErrors(validation(
            value,
            "arc_fault_program",
            validationErrors,
            validateArcFaultProgramValue
        ));

        const newSetting = Object.assign(settings);

        newSetting.arcFaultProgram = value;

        setSettings(newSetting);
    }

    function handleMeanCathodeOverCurrentChanged(value) {
        setValidationErrors(validation(
            value,
            "mean_cathode_over_current",
            validationErrors,
            validateMeanCathodeOverCurrent
        ));

        const newSetting = Object.assign(settings);

        newSetting.meanCathodeOverCurrent = value;

        setSettings(newSetting);
    }

    function handleGridPulsedVoltageChanged(value) {
        setValidationErrors(validation(
            value,
            "grid_pulsed_voltage",
            validationErrors,
            validateGridPulsedVoltage
        ));

        const newSetting = Object.assign(settings);

        newSetting.gridPulsedVoltage = value;

        setSettings(newSetting);
    }

    function handleCathodeVoltageChanged(value) {
        setValidationErrors(validation(
            value,
            "cathode_voltage",
            validationErrors,
            validateCathodeVoltage
        ));

        const newSetting = Object.assign(settings);

        newSetting.cathodeVoltage = value;

        setSettings(newSetting);
    }

    function handleHeaterVoltageChanged(value) {
        setValidationErrors(validation(
            value,
            "heater_voltage",
            validationErrors,
            validateHeaterVoltage
        ));

        const newSetting = Object.assign(settings);

        newSetting.heaterVoltage = value;

        setSettings(newSetting);
    }

    function handleApplyClick() {
        if (hasErrors) return;

        setApplying(true);

        onChanged(pipe.id, {
            "heater_grid_enables": settings.heaterGridEnables,
            "arc_fault_program": settings.arcFaultProgram,
            "mean_cathode_over_current": settings.meanCathodeOverCurrent,
            "grid_pulsed_voltage": settings.gridPulsedVoltage,
            "cathode_voltage": settings.cathodeVoltage,
            "heater_voltage": settings.heaterVoltage
        });

        onApply(pipe.id).finally(() => setApplying(false));
    }

    function handleResetFaultsClick() {
        setApplying(true);

        onActions(pipe.id, ["RESET_FAULTS"]).finally(() => setApplying(false));
    }

    function handleResetArcCounterClick() {
        setApplying(true);

        onActions(pipe.id, ["RESET_ARC_COUNTER"]).finally(() => setApplying(false));
    }

    return {
        settings,
        applying,
        hasErrors,
        validationErrors,
        handleHeaterGridEnablesChanged,
        handleArcFaultProgramChanged,
        handleMeanCathodeOverCurrentChanged,
        handleGridPulsedVoltageChanged,
        handleCathodeVoltageChanged,
        handleHeaterVoltageChanged,
        handleApplyClick,
        handleResetFaultsClick,
        handleResetArcCounterClick
    }
}